import React, { useState, useEffect, useCallback, useRef } from 'react';
import { DS } from '../ds';
const slides = [{
  id: 4,
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/831df720-cd0a-4b82-819e-32bdeba701bc.jpg',
  alt: 'Alineadores invisibles junto a su estuche en un entorno clínico',
  label: 'Ortodoncia invisible',
  title: 'ALINEADORES\nINVISIBLES',
  sub: 'Tecnología de punta para una sonrisa perfecta',
  pill: '✓ Ortodoncia avanzada',
  align: 'center' as const,
  overlay: 'rgba(8,42,55,0.48)',
  objectPosition: 'center',
  objectPositionTablet: 'center',
  objectPositionMobile: '30% center'
}, {
  id: 1,
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/7fefb29e-c878-480a-885e-304c0aab38b9.jpg',
  alt: 'Laboratorio dental certificado INVIMA en Colombia',
  label: 'Respaldo institucional',
  title: 'HABILITADO CON\nCERTIFICACIÓN INVIMA',
  sub: 'Fabricación bajo normativa colombiana vigente',
  pill: '✓ Registro sanitario activo',
  align: 'left' as const,
  overlay: 'rgba(8,42,55,0.52)',
  objectPosition: 'center',
  objectPositionTablet: '100% center',
  objectFitTablet: 'contain' as const,
  objectPositionMobile: '0% center'
}, {
  id: 2,
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/b565b906-f37c-48dd-bb3c-d2e2c6f76d89.jpg',
  alt: 'Kit eco-premium de alineadores con caja kraft y bolsa de lino',
  label: 'Identidad de marca',
  title: 'PRODUCTO\nPERSONALIZADO',
  sub: 'Kit eco-premium con tu marca en cada entrega',
  pill: '✓ Caja kraft · Bolsa lino · Estuche',
  align: 'right' as const,
  overlay: 'rgba(8,42,55,0.45)',
  objectPosition: 'center',
  objectPositionTablet: 'center',
  objectPositionMobile: '34% center'
}, {
  id: 3,
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/bb1f62aa-2170-4e78-9945-8b42b6d2bd10.jpg',
  alt: 'Entrega express de alineadores a toda Colombia',
  label: 'Logística',
  title: 'TIEMPOS DE\nENTREGA EXPRESS',
  sub: 'Respuesta en menos de 24 horas',
  pill: '✓ Envío a toda Colombia',
  align: 'center' as const,
  overlay: 'rgba(8,42,55,0.48)',
  objectPosition: 'center',
  objectPositionTablet: 'center',
  objectPositionMobile: 'center'
}];
const ChevronLeft = () => <svg width="22" height="22" viewBox="0 0 22 22" fill="none" aria-hidden="true" data-id="element-520" data-mp="1o5vii76fzv01">
    <path d="M13.5 17L7.5 11L13.5 5" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" data-id="element-521" data-mp="10gke8fpvvih5" />
  </svg>;
const ChevronRight = () => <svg width="22" height="22" viewBox="0 0 22 22" fill="none" aria-hidden="true" data-id="element-522" data-mp="1af08uso4d9ve">
    <path d="M8.5 17L14.5 11L8.5 5" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" data-id="element-523" data-mp="15em7fth0wy6c" />
  </svg>;
export const HeroBannerSlider = () => {
  const [current, setCurrent] = useState(0);
  const [prev, setPrev] = useState<number | null>(null);
  const [transitioning, setTransitioning] = useState(false);
  const [isPaused, setIsPaused] = useState(false);
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const containerRef = useRef<HTMLDivElement>(null);
  const [width, setWidth] = useState(1400);
  useEffect(() => {
    const el = containerRef.current;
    if (!el) return;
    const ro = new ResizeObserver(([entry]) => {
      setWidth(entry.contentRect.width);
    });
    ro.observe(el);
    setWidth(el.getBoundingClientRect().width);
    return () => ro.disconnect();
  }, []);
  const isMobile = width <= 640;
  const isTablet = width > 640 && width <= 1280;
  const goTo = useCallback((index: number) => {
    if (transitioning || index === current) return;
    setPrev(current);
    setTransitioning(true);
    setTimeout(() => {
      setCurrent(index);
      setPrev(null);
      setTransitioning(false);
    }, 500);
  }, [current, transitioning]);
  const next = useCallback(() => {
    goTo((current + 1) % slides.length);
  }, [current, goTo]);
  const prevSlide = useCallback(() => {
    goTo((current - 1 + slides.length) % slides.length);
  }, [current, goTo]);
  useEffect(() => {
    if (isPaused) return;
    timerRef.current = setTimeout(next, 5000);
    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [current, isPaused, next]);
  const slide = slides[current];
  return <div ref={containerRef} onMouseEnter={() => setIsPaused(true)} onMouseLeave={() => setIsPaused(false)} style={{
    position: 'relative',
    width: '100%',
    height: '800px',
    overflow: 'hidden',
    background: DS.color.tealDeep
  }} data-id="element-524" data-mp="2pva9w2apeeog">
      {/* Slides */}
      {slides.map((s, i) => {
      const isActive = i === current;
      const isPrev = i === prev;
      return <div key={s.id} style={{
        position: 'absolute',
        inset: 0,
        opacity: isActive ? 1 : 0,
        transform: isActive ? 'scale(1)' : isPrev ? 'scale(1.04)' : 'scale(1)',
        transition: isActive ? 'opacity 0.6s ease, transform 6s ease' : isPrev ? 'opacity 0.5s ease, transform 0.5s ease' : 'none',
        zIndex: isActive ? 2 : isPrev ? 1 : 0
      }} data-id="element-525" data-mp="33vtibaj2zmr5" data-mpi={i}>
            <img src={s.image} alt={s.alt} style={{
          position: 'absolute',
          inset: 0,
          objectFit: 'cover',
          objectPosition: s.id === 1 ? isMobile ? '0% center' : isTablet ? '100% center' : 'center' : s.id === 2 && isMobile ? '34% center' : 'center',
          transform: s.id === 1 && isTablet ? 'scale(1.7) translate(8%, 4%)' : 'none',
          transformOrigin: s.id === 1 && isTablet ? '100% 45%' : 'center',
          width: '100%',
          height: '100%',
          display: 'block'
        }} data-id="element-526" data-mp="1eamccxvb8afa" />

            {/* Overlay oscuro */}
            <div aria-hidden="true" style={{
          position: 'absolute',
          inset: 0,
          background: s.overlay
        }} data-id="element-527" data-mp="fnsuos7abtjv" />

            {/* Overlay gradiente inferior */}
            <div aria-hidden="true" style={{
          position: 'absolute',
          inset: 0,
          background: 'linear-gradient(to top, rgba(8,42,55,0.7) 0%, transparent 55%)'
        }} data-id="element-528" data-mp="kofg038x8atm" />
          </div>;
    })}

      {/* Contenido encima */}
      <div style={{
      position: 'absolute',
      inset: 0,
      zIndex: 10,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-end',
      padding: '0 64px 56px',
      textAlign: slide.align === 'center' ? 'center' : 'left',
      alignItems: slide.align === 'right' ? 'flex-end' : slide.align === 'center' ? 'center' : 'flex-start',
      transition: 'all 0.5s ease'
    }} data-id="element-529" data-mp="11yszoiw5r676">
        <div key={`label-${current}`} style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '7px',
        padding: '4px 14px',
        borderRadius: DS.radius.pill,
        background: 'rgba(255,255,255,0.12)',
        backdropFilter: 'blur(8px)',
        WebkitBackdropFilter: 'blur(8px)',
        border: '1px solid rgba(255,255,255,0.2)',
        marginBottom: '16px',
        animation: 'slideUp 0.5s ease both'
      }} data-id="element-530" data-mp="99viyk7lhhgj">
          <div style={{
          width: '6px',
          height: '6px',
          borderRadius: '50%',
          background: DS.color.aquaLight
        }} data-id="element-531" data-mp="rejj0ghhxqbs" />
          <span style={{
          fontFamily: DS.font.body,
          fontSize: '11px',
          fontWeight: 700,
          color: 'rgba(255,255,255,0.85)',
          letterSpacing: '0.1em',
          textTransform: 'uppercase'
        }} data-id="element-532" data-mp="hnov77olqio8">
            {slide.label}
          </span>
        </div>

        <h2 key={`title-${current}`} style={{
        fontFamily: DS.font.heading,
        fontWeight: 800,
        fontSize: 'clamp(2rem, 5vw, 3.6rem)',
        color: '#fff',
        lineHeight: 1.08,
        letterSpacing: '-0.02em',
        margin: '0 0 14px',
        whiteSpace: 'pre-line',
        textShadow: '0 2px 20px rgba(0,0,0,0.3)',
        animation: 'slideUp 0.55s ease 0.05s both'
      }} data-id="element-533" data-mp="3uv06fsud4yht">
          {slide.title}
        </h2>

        <p key={`sub-${current}`} style={{
        fontFamily: DS.font.body,
        fontSize: '15px',
        color: 'rgba(255,255,255,0.75)',
        margin: '0 0 20px',
        fontWeight: 500,
        animation: 'slideUp 0.6s ease 0.1s both'
      }} data-id="element-534" data-mp="2acfw49c36v8u">
          {slide.sub}
        </p>

        <div key={`pill-${current}`} style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '6px',
        padding: '5px 16px',
        borderRadius: DS.radius.pill,
        background: `linear-gradient(135deg, ${DS.color.teal}55, ${DS.color.aqua}44)`,
        backdropFilter: 'blur(10px)',
        WebkitBackdropFilter: 'blur(10px)',
        border: `1px solid ${DS.color.aqua}55`,
        animation: 'slideUp 0.65s ease 0.15s both'
      }} data-id="element-535" data-mp="1mp7r7siklo7c">
          <span style={{
          fontFamily: DS.font.body,
          fontSize: '12px',
          fontWeight: 700,
          color: '#fff',
          letterSpacing: '0.04em'
        }} data-id="element-536" data-mp="meiaxlp3z7f8">
            {slide.pill}
          </span>
        </div>
      </div>

      {/* Flechas */}
      <button onClick={prevSlide} aria-label="Slide anterior" style={{
      position: 'absolute',
      left: '20px',
      top: '50%',
      transform: 'translateY(-50%)',
      zIndex: 20,
      width: '46px',
      height: '46px',
      borderRadius: '50%',
      background: 'rgba(255,255,255,0.12)',
      backdropFilter: 'blur(10px)',
      WebkitBackdropFilter: 'blur(10px)',
      border: '1.5px solid rgba(255,255,255,0.22)',
      color: '#fff',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
      transition: `all 0.22s ${DS.ease.smooth}`
    }} onMouseEnter={e => {
      e.currentTarget.style.background = 'rgba(255,255,255,0.25)';
      e.currentTarget.style.borderColor = 'rgba(255,255,255,0.5)';
    }} onMouseLeave={e => {
      e.currentTarget.style.background = 'rgba(255,255,255,0.12)';
      e.currentTarget.style.borderColor = 'rgba(255,255,255,0.22)';
    }} data-id="element-537" data-mp="3vlszy01j47r7">
        <ChevronLeft data-id="element-538" data-mp="2llfcxpzfw7cw" />
      </button>

      <button onClick={next} aria-label="Siguiente slide" style={{
      position: 'absolute',
      right: '20px',
      top: '50%',
      transform: 'translateY(-50%)',
      zIndex: 20,
      width: '46px',
      height: '46px',
      borderRadius: '50%',
      background: 'rgba(255,255,255,0.12)',
      backdropFilter: 'blur(10px)',
      WebkitBackdropFilter: 'blur(10px)',
      border: '1.5px solid rgba(255,255,255,0.22)',
      color: '#fff',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
      transition: `all 0.22s ${DS.ease.smooth}`
    }} onMouseEnter={e => {
      e.currentTarget.style.background = 'rgba(255,255,255,0.25)';
      e.currentTarget.style.borderColor = 'rgba(255,255,255,0.5)';
    }} onMouseLeave={e => {
      e.currentTarget.style.background = 'rgba(255,255,255,0.12)';
      e.currentTarget.style.borderColor = 'rgba(255,255,255,0.22)';
    }} data-id="element-539" data-mp="2lol378jt1fa7">
        <ChevronRight data-id="element-540" data-mp="2e524lty2vdgi" />
      </button>

      {/* Dots */}
      <div style={{
      position: 'absolute',
      bottom: '20px',
      right: '64px',
      zIndex: 20,
      display: 'flex',
      gap: '8px',
      alignItems: 'center'
    }} data-id="element-541" data-mp="2i2zukyzoa3ky">
        {slides.map((_, i) => <button key={i} onClick={() => goTo(i)} aria-label={`Slide ${i + 1}`} style={{
        width: i === current ? '32px' : '8px',
        height: '8px',
        borderRadius: '4px',
        background: i === current ? '#fff' : 'rgba(255,255,255,0.35)',
        border: 'none',
        cursor: 'pointer',
        padding: 0,
        transition: `all 0.3s ${DS.ease.smooth}`
      }} data-id="element-542" data-mp="z5d4ckutyppd" data-mpi={i} />)}
      </div>

      {/* Barra de progreso inferior */}
      <div key={`progress-${current}`} aria-hidden="true" style={{
      position: 'absolute',
      bottom: 0,
      left: 0,
      height: '3px',
      background: `linear-gradient(90deg, ${DS.color.aquaLight}, ${DS.color.aqua})`,
      animation: isPaused ? 'none' : 'progressBar 5s linear both',
      zIndex: 20
    }} data-id="element-543" data-mp="bdxwkckabg6q" />

      {/* Keyframes */}
      <style data-id="element-544" data-mp="2s3jyhhbaj2d7">{`
        @keyframes slideUp {
          from { opacity: 0; transform: translateY(18px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        @keyframes progressBar {
          from { width: 0%; }
          to   { width: 100%; }
        }
      `}</style>
    </div>;
};